import { CrmReportItem } from './reports'

export type DealReport = {
  company_id?: number
  id: number
  cc_id?: number
  close_date_override?: string
  created?: string
  modified?: string
  origin_campaign_id?: number
  identifier?: string
  apply_to?: string
  doors_count?: number
  monthly_volume_override?: number
  monthly_revenue_override?: number
  last_datetime_stage_changed?: string
  deal_name?: string
  sales_stage_id?: number
  sales_stage_name?: string
  account_owner_id?: number
  account_owner_name?: string
  deal_display_name?: string
  expected_days_to_close?: number
  days_since_last_modified?: number
  days_since_deal_last_modified?: number
  cc_overriden_domain?: string
  cc_overriden_name?: string
  cc_category_id?: number
  cc_category_name?: string
  cc_sub_category_id?: number
  cc_sub_category_name?: string
  cc_created?: string
  cc_note_count?: number
  cc_deal_count?: number
  cc_contact_count?: number
  cc_doors_cnt?: number
  cc_days_since_last_modified?: number
  cc_company_type?: string
  cc_company_name?: string
  cc_firstbite_id?: string
  cc_chain_id?: number
  cc_lodging_id?: number
  cc_cstore_id?: number
  cc_university_id?: number
  cc_k12district_id?: number
  cc_nursinghome_id?: number
  cc_hospital_id?: number
  cc_distributors?: CrmReportItem[]
  cc_gpos?: CrmReportItem[]
  cc_taglist?: CrmReportItem[]
  estimated_meals_per_day?: number
  operational_schools?: number
  product_name?: string
  product_id?: number
  product_variant_id?: number
  product_variant_name?: string
  contact_tags?: CrmReportItem[]
  deal_taglist?: CrmReportItem[]
  deal_taglist_names?: string
  origin_campaign_name?: string
  days_since_sent?: number
  days_since_reply?: number
  monthly_revenue_predicted?: number
  monthly_volume_predicted?: number
  annual_brand_opp?: number
  annual_revenue?: number
  annual_volume?: number
  annual_total?: number
  // Flag indicating if the product is a non-recurring revenue product
  // For non-recurring products, monthly values are N/A and 1yr values don't multiply by 12
  is_not_recurring?: boolean
}

export function isDealReport(obj: any): obj is DealReport {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    'id' in obj &&
    'company_id' in obj &&
    'deal_name' in obj
  )
}
